import { render, staticRenderFns } from "./PageCollection.vue?vue&type=template&id=3329616c&"
import script from "./PageCollection.vue?vue&type=script&lang=js&"
export * from "./PageCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports